var map = {
	"./astronauts_hold_hand.png": 194,
	"./autorenew.svg": 195,
	"./bug.png": 196,
	"./cosmonaut.jpg": 197,
	"./features.jpg": 198,
	"./feedback.png": 199,
	"./idea.png": 200,
	"./inventorize.png": 201,
	"./logo_60.png": 202,
	"./os_linux.png": 203,
	"./os_mac.png": 204,
	"./os_win.png": 205,
	"./processes.png": 206,
	"./remote_execution.png": 207,
	"./roadmap.png": 208,
	"./scheme_old.png": 209,
	"./spaceship.png": 210,
	"./storage.png": 211,
	"./telegram.png": 212,
	"./visual_control.png": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;